// Where to send a reader after sign-in. Only same-origin paths are honoured.
export function safeNextPath(search: string, fallback = '/dashboard'): string {
  const next = new URLSearchParams(search).get('next');
  if (!next || !next.startsWith('/') || next.startsWith('//') || next.includes('\\')) return fallback;
  return next;
}
